<script>
  import moment from 'moment';
  import DatePicker from 'vue2-datepicker';
  import conciliacaoProjetoServico from '../servico';
  import SelecaoBusca from './SelecaoBusca.vue';
  import RateioProjetos from './RateioProjetos.vue';
  import PernasTransitoria from './PernasTransitoria.vue';
  import ComplementoSugerido from './ComplementoSugerido.vue';
  import sugestoesDoHistorico from '../sugestoes-historico';
  import BlocoOperacao from './BlocoOperacao.vue';
  import AnexosOperacao from './AnexosOperacao.vue';
  import anexosMixin, { DESTINO_LANCAMENTO, DESTINO_CONTA_RECEBER, DESTINO_SOLICITACAO } from '../anexos';

  export default {
    components: { SelecaoBusca, DatePicker, RateioProjetos, PernasTransitoria, ComplementoSugerido,
                  BlocoOperacao, AnexosOperacao },
    mixins: [anexosMixin],
    props: {
      idContaCript: { type: String, required: true },
      debito: { type: Object, required: true },
      nomeContaTransitoria: { type: String, default: '' },
    },
    data() {
      return {
        gravando: false,
        carregando: true,
        validar: false,
        viaSolicitacao: null,
        criarContaReceber: false,
        comTaxa: false,
        mostrarCheckTaxa: false,
        usaCategoria: false,
        categoriaObrigatoria: false,
        origem: null,
        textosDocumento: [],
        textosComplemento: [],
        anexosCr: [],
        pernasValidas: false,
        transf: {
          pernas: [],
          data: null,
          documento: '',
          complemento: '',
          idUsuarioLiberacao: 0, nomeUsuarioLiberacao: '',
          observacao: '',
        },
        form: {
          rateios: [],
          idTerceiro: 0, nomeTerceiro: '',
          tipoPessoa: 0,
          historico: '',
          idCategoriaFinanceira: 0, nomeCategoriaFinanceira: '',
          dataEmissao: null,
          dataVencimento: null,
          dataBaixa: null,
          documento: '',
          complemento: '',
        },
      }
    },
    computed: {
      observacaoPorPerna() { return this.viaSolicitacao === true && this.transf.pernas.length > 1; },
      seloTransferencia() { return this.viaSolicitacao === true ? 'SOL' : 'TRANSF'; },
      corTransferencia() { return this.viaSolicitacao === true ? 'amb' : 'azu'; },
      tituloTransferencia() {
        return this.viaSolicitacao === true ? 'Solicitação de transferência' : 'Transferência entre contas';
      },
      subtituloTransferencia() {
        if (this.viaSolicitacao === true) return 'Nasce aguardando liberação — vira lançamento quando for liberada';
        if (this.viaSolicitacao === false) return 'Duas pernas lançadas agora, entre as contas reais';
        return 'Move o valor entre duas contas reais — a transitória não entra';
      },
      podeAnexarTransferencia() {
        if (this.viaSolicitacao === true) return this.podeAnexarSolicitacao;
        if (this.viaSolicitacao === false) return this.podeAnexarLancamento;
        return false;
      },
      anexoTransferencia() {
        if (!this.podeAnexarTransferencia) return null;

        return {
          limite: this.limiteAnexo,
          titulo: this.viaSolicitacao === true ? 'Arquivos da solicitação' : 'Arquivos da transferência',
          dica: this.viaSolicitacao === true
            ? 'Os arquivos vão para a pasta desta solicitação de transferência.'
            : 'Os arquivos vão para a pasta de lançamentos, nas duas pernas desta transferência.',
        };
      },
      valor() { return this.origem ? this.origem.valor : (this.debito.valor || 0); },
      valorAbs() { return Math.abs(this.valor); },
      baixarAgora() { return this.viaSolicitacao === false; },
      chaveTaxa() {
        if (!this.criarContaReceber || !this.baixarAgora) return '';
        return this.form.rateios.filter(r => r.idProjeto > 0).map(r => r.idProjeto).join(',');
      },
      semCliente() { return this.form.tipoPessoa === 3; },
      sugestoesHistorico() { return sugestoesDoHistorico(this.origem && this.origem.historico, 110); },
      rateioValido() {
        const rateios = this.form.rateios;

        if (!rateios || rateios.length === 0) return false;
        if (rateios.some(r => !(r.idProjeto > 0) || !(r.idRubrica > 0) || !(r.idSubRubrica > 0))) return false;
        if (rateios.some(r => !((+r.valor || 0) > 0))) return false;

        const chaves = rateios.map(r => r.idProjeto + '-' + r.idRubrica + '-' + r.idSubRubrica);
        if (chaves.some((c, i) => chaves.indexOf(c) !== i)) return false;

        const soma = rateios.reduce((s, r) => s + (+r.valor || 0), 0);

        return Math.abs(Math.round((soma - this.valorAbs) * 100) / 100) < 0.005;
      },
      erros() {
        const e = {};

        if (!this.pernasValidas) e.pernas = 'Complete as contas da transferência';
        if (!this.transf.data) e.dataTransferencia = 'Campo obrigatório';
        if (this.viaSolicitacao === null) e.modo = 'Escolha como lançar a transferência';

        if (this.viaSolicitacao === true) {
          if (!this.transf.idUsuarioLiberacao) e.liberador = 'Campo obrigatório';
          if (!this.observacaoPorPerna && !(this.transf.observacao || '').trim()) e.observacao = 'Campo obrigatório';
        }

        if (this.criarContaReceber) {
          if (!this.form.tipoPessoa) e.tipoPessoa = 'Escolha o tipo';
          if (this.form.tipoPessoa > 0 && !this.semCliente && !this.form.idTerceiro) e.cliente = 'Campo obrigatório';
          if (this.semCliente && !this.form.historico.trim()) e.historico = 'Campo obrigatório';
          if (this.categoriaObrigatoria && !(this.form.idCategoriaFinanceira > 0)) e.categoria = 'Campo obrigatório';
          if (!this.rateioValido) e.rateio = 'Complete o rateio entre os projetos';
          if (this.baixarAgora && !this.form.dataBaixa) e.dataBaixa = 'Campo obrigatório';
          if (!this.form.dataVencimento) e.vencimento = 'Campo obrigatório';
        }

        return e;
      },
    },
    watch: {
      'transf.pernas.length'() { this.espalharObservacao(); },
      chaveTaxa(chave) { this.carregarCheckTaxa(chave); },
      viaSolicitacao() { this.espalharObservacao(); },
    },
    mounted() {
      this.carregarDebito();
      this.carregarTextosPadrao();
      this.carregarConfigAnexos();
      this.carregarRegraCategoria();
    },
    methods: {
      erro(campo) { return this.validar ? this.erros[campo] : ''; },
      carregarCheckTaxa(chave) {
        if (!chave) {
          this.mostrarCheckTaxa = false;
          this.comTaxa = false;
          return;
        }

        conciliacaoProjetoServico.checkTaxa(this.idContaCript, { idsProjeto: chave.split(',').map(x => +x) })
          .then(r => {
            if (this.chaveTaxa !== chave) return;
            this.mostrarCheckTaxa = !!(r && r.mostrar);
            this.comTaxa = !!(r && r.marcado);
          })
          .catch(() => { this.mostrarCheckTaxa = false; this.comTaxa = false; });
      },
      carregarRegraCategoria() {
        conciliacaoProjetoServico.regraCategoria(this.idContaCript)
          .then(r => {
            this.usaCategoria = !!(r && r.utiliza);
            this.categoriaObrigatoria = this.usaCategoria && !!(r && r.obrigatoria);
          })
          .catch(() => { this.usaCategoria = true; this.categoriaObrigatoria = false; });
      },
      espalharObservacao() {
        if (!this.observacaoPorPerna) return;

        const texto = (this.transf.observacao || '').trim();

        if (!texto) return;

        this.transf.pernas.forEach(perna => {
          if (!(perna.observacao || '').trim()) this.$set(perna, 'observacao', texto);
        });
      },
      carregarDebito() {
        this.carregando = true;
        conciliacaoProjetoServico.debitoTransitoria(this.idContaCript, this.debito.idLancamento)
          .then(dados => {
            this.origem = dados;
            this.carregando = false;

            if (dados.idTerceiro > 0) {
              this.form.idTerceiro = dados.idTerceiro;
              this.form.nomeTerceiro = dados.nomeTerceiro;
            }

            this.form.dataEmissao = dados.dataStr ? moment(dados.dataStr, 'DD/MM/YYYY').toDate() : null;
            this.form.dataVencimento = this.form.dataEmissao;

            if (dados.idContaOrigem > 0)
              this.transf.pernas = [{
                idContaOrigem: dados.idContaOrigem, nomeContaOrigem: dados.nomeContaOrigem,
                idContaDestino: 0, nomeContaDestino: '',
                valor: 0, valorTexto: '',
                observacao: '', observacaoSugerida: '',
                anexos: [],
              }];
          })
          .catch(() => {
            this.carregando = false;
            toastr.error('Não foi possível carregar o lançamento de débito.');
            this.$emit('fechar');
          });
      },
      carregarTextosPadrao() {
        conciliacaoProjetoServico.textosPadrao()
          .then(dados => {
            this.textosDocumento = (dados && dados.documentos) || [];
            this.textosComplemento = (dados && dados.complementos) || [];
          })
          .catch(() => {});
      },
      buscarContas(termo) { return conciliacaoProjetoServico.contasGerais(termo, true); },
      buscarUsuarios(termo) { return conciliacaoProjetoServico.usuariosLiberacao(termo); },
      buscarPessoas(termo) { return conciliacaoProjetoServico.pessoasCredito(termo, this.form.tipoPessoa); },
      buscarCategorias(termo) { return conciliacaoProjetoServico.categoriasFinanceiras(termo); },
      ativarContaReceber() {
        if (!this.criarContaReceber) this.criarContaReceber = true;
      },
      escolherTipoPessoa(tipo) {
        if (this.form.tipoPessoa === tipo) return;

        this.form.tipoPessoa = tipo;
        this.form.idTerceiro = 0;
        this.form.nomeTerceiro = '';

        if (tipo > 0) this.form.historico = '';
      },
      aoEscolherCliente(opcao) {
        this.form.nomeTerceiro = opcao ? opcao.nome : '';
      },
      rateioParaEnvio() {
        return this.form.rateios.map(r => ({
          idProjeto: r.idProjeto,
          idRubrica: r.idRubrica,
          idSubRubrica: r.idSubRubrica,
          valor: +r.valor || 0,
        }));
      },
      formatar(v) {
        return (v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      dataStr(d) { return d ? moment(d).format('YYYY-MM-DD') : ''; },
      enviosAnexos(resultado) {
        const pernas = this.transf.pernas;
        const multi = pernas.length > 1;
        const idsSolicitacao = resultado.idsSolicitacaoTransferencia && resultado.idsSolicitacaoTransferencia.length
          ? resultado.idsSolicitacaoTransferencia : [resultado.idSolicitacaoTransferencia];
        const idsLancamento = resultado.idsLancamentoTransferencia && resultado.idsLancamentoTransferencia.length
          ? resultado.idsLancamentoTransferencia
          : [resultado.idLancamentoDebitoTransferencia, resultado.idLancamentoCreditoTransferencia];

        const envios = pernas.map((perna, i) => {
          const sufixo = multi ? ' ' + (i + 1) : '';

          return this.viaSolicitacao === true
            ? { destino: DESTINO_SOLICITACAO, rotulo: 'solicitação de transferência' + sufixo,
                ids: [idsSolicitacao[i]], arquivos: perna.anexos || [] }
            : { destino: DESTINO_LANCAMENTO, rotulo: 'transferência' + sufixo,
                ids: [idsLancamento[i * 2], idsLancamento[i * 2 + 1]], arquivos: perna.anexos || [] };
        });

        if (this.criarContaReceber)
          envios.push({
            destino: DESTINO_CONTA_RECEBER, rotulo: 'contas a receber',
            ids: [resultado.idContaReceber], arquivos: this.anexosCr,
          });

        return envios;
      },
      gravar() {
        if (this.gravando || this.carregando) return;

        this.validar = true;

        if (Object.keys(this.erros).length > 0) {
          toastr.error('Preencha os campos obrigatórios destacados.');
          return;
        }

        this.gravando = true;

        const payload = {
          idLancamentoDebito: this.debito.idLancamento,
          operacao: 'TRANSFERENCIA',
          criarContaReceber: this.criarContaReceber,
          baixarAgora: this.criarContaReceber && this.baixarAgora,
          dataBaixa: this.criarContaReceber && this.baixarAgora ? this.dataStr(this.form.dataBaixa) : '',
          contaReceber: this.criarContaReceber ? {
            rateios: this.rateioParaEnvio(),
            idTerceiro: this.semCliente ? 0 : this.form.idTerceiro,
            historico: this.semCliente ? this.form.historico.trim() : '',
            dataEmissao: this.dataStr(this.form.dataEmissao),
            dataVencimento: this.dataStr(this.form.dataVencimento),
            idCategoriaFinanceira: this.form.idCategoriaFinanceira,
            documento: this.form.documento,
            complemento: this.form.complemento,
            valor: this.valorAbs,
            comTaxa: this.baixarAgora && this.mostrarCheckTaxa && this.comTaxa,
          } : null,
          criarTransferencia: true,
          transferencias: this.transf.pernas.map(perna => ({
            idContaOrigem: perna.idContaOrigem,
            idContaDestino: perna.idContaDestino,
            valor: perna.valor,
            observacao: this.observacaoPorPerna ? (perna.observacao || '') : (this.transf.observacao || ''),
          })),
          dataTransferencia: this.dataStr(this.transf.data),
          documentoTransferencia: this.transf.documento,
          complementoTransferencia: this.transf.complemento,
          transferenciaViaSolicitacao: this.viaSolicitacao === true,
          idUsuarioLiberacao: this.viaSolicitacao === true ? this.transf.idUsuarioLiberacao : 0,
          observacaoSolicitacao: this.viaSolicitacao === true ? this.transf.observacao : '',
        };

        conciliacaoProjetoServico.regularizarTransitoria(this.idContaCript, payload)
          .then(resultado => {
            return this.enviarAnexos(this.enviosAnexos(resultado)).then(() => {
              this.gravando = false;
              (resultado.mensagens || []).forEach(m => toastr.success(m));
              this.$emit('concluido', resultado);
            });
          })
          .catch(resposta => {
            this.gravando = false;
            const mensagem = resposta && resposta.data ? resposta.data.message : '';
            toastr.error(mensagem || 'Não foi possível criar a transferência.');
          });
      },
    },
    template: `
      <div class="trt-back" @click.self="$emit('fechar')">
        <div class="trt-modal">
          <div class="trt-cab">
            <h4><i class="fa fa-exchange"></i> Criar transferência</h4>
            <small>Move o valor entre duas contas reais — a conta transitória não entra na transferência.</small>
          </div>

          <div class="trt-corpo">
            <div v-if="carregando" class="trt-carregando"><i class="fa fa-spinner fa-pulse"></i> Carregando o débito...</div>

            <template v-else>
              <div class="trt-resumo">
                <div class="trt-res-item">
                  <span>Débito na transitória</span>
                  <b class="mono">R$ {{ formatar(valorAbs) }}</b>
                </div>
                <div class="trt-res-item">
                  <span>Data</span>
                  <b class="mono">{{ origem.dataStr }}</b>
                </div>
                <div class="trt-res-item trt-res-lg">
                  <span>Histórico</span>
                  <b>{{ origem.historico || '—' }}</b>
                </div>
              </div>

              <bloco-operacao :selo="seloTransferencia" :cor="corTransferencia" :titulo="tituloTransferencia"
                              :subtitulo="subtituloTransferencia">
              <pernas-transitoria v-model="transf.pernas" :total="valorAbs" :buscar="buscarContas"
                                  :validar="validar" :com-observacao="viaSolicitacao === true" :anexo="anexoTransferencia"
                                  :dica-origem="origem.idContaOrigem > 0 ? 'Sugerida pelo crédito que originou este débito.' : ''"
                                  @valido="v => pernasValidas = v"></pernas-transitoria>
              <div class="trt-linha">
                <div class="trt-campo trt-campo-sm" :class="{ 'trt-invalido': erro('dataTransferencia') }">
                  <label>Data <span class="trt-obr">*</span></label>
                  <date-picker v-model="transf.data" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                               :editable="false" :shortcuts="false" :clearable="false" :append-to-body="true"
                               :popup-style="{ zIndex: 3200 }" placeholder="Informe a data" style="width:100%"></date-picker>
                  <span v-if="erro('dataTransferencia')" class="trt-msg">{{ erro('dataTransferencia') }}</span>
                </div>
                <div class="trt-campo">
                  <label>Documento</label>
                  <complemento-sugerido v-model="transf.documento" :digitados="[transf.complemento]" titulo-digitados="Do complemento" :cadastrados="textosDocumento" :maxlength="30"
                                        placeholder="Clique para ver os textos cadastrados"></complemento-sugerido>
                </div>
                <div class="trt-campo trt-campo-lg">
                  <label>Complemento</label>
                  <complemento-sugerido v-model="transf.complemento" :digitados="[transf.documento]" titulo-digitados="Do documento" :cadastrados="textosComplemento" :maxlength="300"
                                        placeholder="Clique para ver os textos cadastrados"></complemento-sugerido>
                </div>
              </div>

              <div class="trt-opcoes" :class="{ 'trt-opcoes-erro': erro('modo') }">
                <label class="trt-radio" :class="{ 'trt-radio-on': viaSolicitacao === false }">
                  <input type="radio" :value="false" v-model="viaSolicitacao">
                  <span><b>Lançar direto</b><small>gera a transferência já executada</small></span>
                </label>
                <label class="trt-radio" :class="{ 'trt-radio-on': viaSolicitacao === true }">
                  <input type="radio" :value="true" v-model="viaSolicitacao">
                  <span><b>Criar solicitação</b><small>alguém libera antes de virar lançamento</small></span>
                </label>
              </div>
              <span v-if="erro('modo')" class="trt-msg">{{ erro('modo') }}</span>

              <div v-if="viaSolicitacao === true" class="trt-linha trt-linha-topo">
                <div class="trt-campo trt-campo-lg" :class="{ 'trt-invalido': erro('liberador') }">
                  <label>Quem libera <span class="trt-obr">*</span></label>
                  <selecao-busca v-model="transf.idUsuarioLiberacao" :texto="transf.nomeUsuarioLiberacao" :buscar="buscarUsuarios"
                                 placeholder="Buscar pessoa..."
                                 @selecionado="o => transf.nomeUsuarioLiberacao = o ? o.nome : ''"></selecao-busca>
                  <span v-if="erro('liberador')" class="trt-msg">{{ erro('liberador') }}</span>
                </div>
                <div v-if="!observacaoPorPerna" class="trt-campo trt-campo-lg" :class="{ 'trt-invalido': erro('observacao') }">
                  <label>Observação <span class="trt-obr">*</span></label>
                  <input type="text" class="form-control" maxlength="300" v-model="transf.observacao">
                  <span v-if="erro('observacao')" class="trt-msg">{{ erro('observacao') }}</span>
                </div>
              </div>
              </bloco-operacao>

              <label class="trt-tgl">
                <input type="checkbox" v-model="criarContaReceber">
                <span>Criar também o contas a receber</span>
              </label>
              <div class="trt-aviso">
                Marque quando <b>não</b> existir contas a receber para este valor. O título nasce com a conta
                transitória como conta de baixa. Sem marcar, o débito de R$ {{ formatar(valorAbs) }} continua
                pendente com a transferência anotada no complemento.
              </div>

              <div class="trt-cr" :class="{ 'trt-cr-off': !criarContaReceber }" @click="ativarContaReceber">
                <bloco-operacao selo="CR" cor="cre" titulo="Contas a receber"
                                subtitulo="Título criado junto, com a conta transitória como conta de baixa">
                <div v-if="!criarContaReceber" class="trt-cr-dica">
                  Marque <b>Criar também o contas a receber</b> acima, ou clique aqui, para preencher o título.
                </div>

                <div class="trt-regra" v-if="viaSolicitacao === null">
                  <i class="fa fa-info-circle"></i>
                  Escolha antes como a transferência será lançada — é isso que define se o título já nasce baixado.
                </div>
                <div class="trt-regra trt-regra-ok" v-else-if="baixarAgora">
                  <i class="fa fa-check-circle"></i>
                  Transferência direta: o título <b>já nasce baixado</b>, conciliado com este débito na data da baixa.
                </div>
                <div class="trt-regra" v-else>
                  <i class="fa fa-clock-o"></i>
                  Transferência por solicitação: o título fica <b>em aberto</b>, sem data de baixa — baixe depois que o crédito entrar.
                </div>

                <div class="trt-linha trt-linha-topo">
                  <div class="trt-campo trt-campo-lg" :class="{ 'trt-invalido': erro('cliente') || erro('historico') || erro('tipoPessoa') }">
                    <label>Cliente <span class="trt-obr">*</span></label>
                    <div class="trt-seg">
                      <button type="button" :class="{ ativo: form.tipoPessoa === 1 }" @click="escolherTipoPessoa(1)">Pessoa física</button>
                      <button type="button" :class="{ ativo: form.tipoPessoa === 2 }" @click="escolherTipoPessoa(2)">Pessoa jurídica</button>
                      <button type="button" :class="{ ativo: form.tipoPessoa === 3 }" @click="escolherTipoPessoa(3)">Outros</button>
                    </div>
                    <selecao-busca v-if="form.tipoPessoa > 0 && !semCliente" v-model="form.idTerceiro" :texto="form.nomeTerceiro"
                                   :buscar="buscarPessoas" :placeholder="form.tipoPessoa === 1 ? 'Nome ou CPF...' : 'Nome ou CNPJ...'"
                                   @selecionado="aoEscolherCliente"></selecao-busca>
                    <complemento-sugerido v-if="semCliente" v-model="form.historico" :sugestoes="sugestoesHistorico" :maxlength="110"
                                          titulo-sugestoes="Histórico do débito na transitória"
                                          placeholder="Clique para ver o histórico do débito"></complemento-sugerido>
                    <span v-if="erro('tipoPessoa')" class="trt-msg">{{ erro('tipoPessoa') }}</span>
                    <span v-else-if="erro('cliente')" class="trt-msg">{{ erro('cliente') }}</span>
                    <span v-else-if="erro('historico')" class="trt-msg">{{ erro('historico') }}</span>
                    <small v-else-if="semCliente" class="trt-dica">O título nasce sem cliente, com este histórico.</small>
                  </div>
                </div>

                <div class="trt-rateio">
                  <rateio-projetos v-model="form.rateios" :id-conta-cript="idContaCript" :total="valorAbs"
                                   natureza="C" :projetos-livres="true" :validar="validar && criarContaReceber"
                                   titulo="Rateio entre projetos"></rateio-projetos>
                </div>

                <div class="trt-linha">
                  <div class="trt-campo trt-campo-sm" v-if="baixarAgora" :class="{ 'trt-invalido': erro('dataBaixa') }">
                    <label>Data da baixa <span class="trt-obr">*</span></label>
                    <date-picker v-model="form.dataBaixa" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                                 :editable="false" :shortcuts="false" :clearable="false" :append-to-body="true"
                                 :popup-style="{ zIndex: 3200 }" placeholder="Informe a data" style="width:100%"></date-picker>
                    <span v-if="erro('dataBaixa')" class="trt-msg">{{ erro('dataBaixa') }}</span>
                    <small v-else class="trt-dica">Não precisa ser a data do débito.</small>
                  </div>
                  <div class="trt-campo trt-campo-lg">
                    <label>Conta de baixa</label>
                    <input type="text" class="form-control" :value="nomeContaTransitoria || 'Conta transitória'" disabled>
                  </div>
                </div>

                <label v-if="baixarAgora && mostrarCheckTaxa" class="trt-check">
                  <input type="checkbox" v-model="comTaxa">
                  <span>Taxa <small>marcado quando o projeto tem taxa cadastrada</small></span>
                </label>

                <div class="trt-linha">
                  <div class="trt-campo">
                    <label>Documento</label>
                    <complemento-sugerido v-model="form.documento" :digitados="[form.complemento]" titulo-digitados="Do complemento" :cadastrados="textosDocumento" :maxlength="30"
                                          placeholder="Clique para ver os textos cadastrados"></complemento-sugerido>
                  </div>
                  <div class="trt-campo trt-campo-sm">
                    <label>Emissão</label>
                    <date-picker v-model="form.dataEmissao" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                                 :editable="false" :shortcuts="false" :clearable="false" :append-to-body="true"
                                 :popup-style="{ zIndex: 3200 }" style="width:100%"></date-picker>
                  </div>
                  <div class="trt-campo trt-campo-sm" :class="{ 'trt-invalido': erro('vencimento') }">
                    <label>Vencimento <span class="trt-obr">*</span></label>
                    <date-picker v-model="form.dataVencimento" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                                 :editable="false" :shortcuts="false" :clearable="false" :append-to-body="true"
                                 :popup-style="{ zIndex: 3200 }" placeholder="Informe a data" style="width:100%"></date-picker>
                    <span v-if="erro('vencimento')" class="trt-msg">{{ erro('vencimento') }}</span>
                  </div>
                </div>

                <div class="trt-linha">
                  <div class="trt-campo trt-campo-lg" v-if="!form.semCliente">
                    <label>Histórico</label>
                    <input type="text" class="form-control" :value="form.nomeTerceiro" disabled>
                    <small class="trt-dica">Vem do cliente do título.</small>
                  </div>
                  <div class="trt-campo trt-campo-lg">
                    <label>Complemento</label>
                    <complemento-sugerido v-model="form.complemento" :digitados="[form.documento]" titulo-digitados="Do documento" :cadastrados="textosComplemento" :maxlength="300"
                                          placeholder="Clique para ver os textos cadastrados"></complemento-sugerido>
                  </div>
                  <div v-if="usaCategoria" class="trt-campo trt-campo-lg"
                       :class="{ 'trt-invalido': erro('categoria') }">
                    <label>Categoria financeira <span v-if="categoriaObrigatoria" class="trt-obr">*</span></label>
                    <selecao-busca v-model="form.idCategoriaFinanceira" :texto="form.nomeCategoriaFinanceira"
                                   :buscar="buscarCategorias" placeholder="Buscar categoria..."
                                   @selecionado="o => form.nomeCategoriaFinanceira = o ? o.nome : ''"></selecao-busca>
                    <span v-if="erro('categoria')" class="trt-msg">{{ erro('categoria') }}</span>
                  </div>
                </div>

                <anexos-operacao v-if="podeAnexarContaReceber && criarContaReceber" v-model="anexosCr" :limite="limiteAnexo"
                                 titulo="Arquivos do contas a receber"
                                 dica="Os arquivos vão para a pasta do contas a receber assim que o título for criado."></anexos-operacao>
                </bloco-operacao>
              </div>
            </template>
          </div>

          <div class="trt-rodape">
            <button type="button" class="btn btn-default" @click="$emit('fechar')">Cancelar</button>
            <button type="button" class="btn btn-primary" :disabled="gravando || carregando" @click="gravar">
              <i class="fa" :class="gravando ? 'fa-spinner fa-pulse' : 'fa-check'"></i>
              {{ criarContaReceber ? 'Criar transferência e título' : (viaSolicitacao === true ? 'Criar solicitação' : 'Criar transferência') }}
            </button>
          </div>
        </div>
      </div>`,
  }
</script>

<style scoped>
  .trt-back { position: fixed; inset: 0; background: rgba(16,24,40,.45); z-index: 3100; display: flex; align-items: center; justify-content: center; padding: 20px; }
  .trt-modal { background: #fff; border-radius: 8px; box-shadow: 0 18px 48px rgba(16,24,40,.24); width: 100%; max-width: 900px; max-height: 92vh; display: flex; flex-direction: column; }
  .trt-cab { padding: 16px 20px 12px; border-bottom: 1px solid #e6eaee; }
  .trt-cab h4 { margin: 0 0 3px; font-size: 17px; font-weight: 600; color: #1c2024; }
  .trt-cab small { color: #8a939c; font-size: 12.5px; }
  .trt-corpo { padding: 16px 20px; overflow: auto; flex: 1; }
  .trt-carregando { padding: 30px; text-align: center; color: #8a939c; }
  .trt-resumo { display: flex; gap: 18px; flex-wrap: wrap; background: #f6f8fa; border: 1px solid #e6eaee; border-radius: 6px; padding: 10px 14px; margin-bottom: 16px; }
  .trt-res-item { display: flex; flex-direction: column; gap: 2px; min-width: 120px; }
  .trt-res-item span { font-size: 11px; text-transform: uppercase; letter-spacing: .3px; color: #8a939c; }
  .trt-res-item b { font-size: 14px; color: #1c2024; }
  .trt-res-lg { flex: 1; min-width: 240px; }
  .trt-res-lg b { font-weight: 500; font-size: 13px; }
  .mono { font-family: Consolas, Menlo, monospace; }
  .trt-sub-tit { font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: .4px; color: #6b747e; margin: 10px 0 10px; }
  .trt-linha { display: flex; gap: 12px; flex-wrap: wrap; margin-bottom: 12px; }
  .trt-rateio { margin-bottom: 12px; }
  .trt-linha-topo { margin-top: 10px; }
  .trt-campo { flex: 1; min-width: 160px; }
  .trt-campo-lg { flex: 2; min-width: 220px; }
  .trt-campo-sm { flex: 0 0 170px; min-width: 170px; }
  .trt-campo label { display: block; font-size: 12px; font-weight: 600; color: #4b545e; margin-bottom: 4px; }
  .trt-obr { color: #c0392b; }
  .trt-tgl { display: flex; align-items: center; gap: 8px; margin: 12px 0 4px; font-size: 13px; font-weight: 600; color: #1c2024; cursor: pointer; }
  .trt-tgl input { margin: 0; }
  .trt-check { display: flex; align-items: center; gap: 8px; margin: -4px 0 12px; font-size: 12.5px; font-weight: 600; color: #5b6570; cursor: pointer; }
  .trt-check input { margin: 0; }
  .trt-check small { font-weight: 400; color: #8a94a0; margin-left: 4px; }
  .trt-aviso { font-size: 12px; color: #8a5a00; background: #fdf3e0; border: 1px solid #f0d9a8; border-radius: 5px; padding: 7px 10px; margin-bottom: 4px; }
  .trt-cr { margin-top: 4px; }
  .trt-cr-off { opacity: .5; cursor: pointer; }
  .trt-cr-dica { font-size: 12px; color: #8a5a00; background: #fdf9ef; border: 1px solid #f0d9a8; border-radius: 6px; padding: 7px 10px; margin-bottom: 8px; }
  .trt-seg { display: flex; border: 1px solid #c7cdd4; border-radius: 5px; overflow: hidden; height: 32px; margin-bottom: 6px; }
  .trt-seg button { flex: 1; border: none; background: #fff; color: #5b6570; font-size: 12.5px; padding: 0 8px; cursor: pointer; border-left: 1px solid #e2e6ea; white-space: nowrap; }
  .trt-seg button:first-child { border-left: none; }
  .trt-seg button:hover { background: #f4f6f8; }
  .trt-seg button.ativo { background: #1ab394; color: #fff; font-weight: 600; }
  .trt-dica { display: block; margin-top: 3px; font-size: 11.5px; color: #8a939c; }
  .trt-msg { display: block; margin-top: 4px; font-size: 11.5px; color: #c0392b; }
  .trt-regra { display: flex; align-items: flex-start; gap: 8px; font-size: 12.5px; color: #3b4a5a; background: #f1f5f9; border: 1px solid #dbe3ec; border-radius: 5px; padding: 8px 11px; margin-bottom: 4px; }
  .trt-regra-ok { color: #0a6d4d; background: #f2faf6; border-color: #bfe3d1; }
  .trt-regra .fa { margin-top: 2px; }
  .trt-opcoes { display: flex; gap: 12px; flex-wrap: wrap; margin-bottom: 4px; }
  .trt-opcoes-erro .trt-radio { border-color: #c0392b; background: #fdf6f5; }
  .trt-radio { flex: 1; min-width: 200px; display: flex; align-items: flex-start; gap: 8px; border: 1px solid #d3d8de; border-radius: 6px; padding: 9px 12px; margin: 0; cursor: pointer; font-weight: 400; }
  .trt-radio-on { border-color: #2b6cb0; background: #f3f8fd; }
  .trt-radio input { margin: 2px 0 0; }
  .trt-radio b { display: block; font-size: 13px; color: #1c2024; }
  .trt-radio small { color: #8a939c; font-size: 11.5px; }
  .trt-rodape { padding: 12px 20px; border-top: 1px solid #e6eaee; display: flex; justify-content: flex-end; gap: 8px; }
</style>

<style>
  .trt-invalido .form-control,
  .trt-invalido .mx-input { border-color: #c0392b; background: #fdf6f5; }
  .trt-invalido label { color: #c0392b; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/TransferenciaTransitoriaModal.vue